export const environment = {
  version: 'develop',
  buildDate: '202610301313',
  environment: 'develop',
  release: '678d677e2ffe162c8dd98456d8ca555c41cf1ee2',
  production: false,
  debug: true,
  baseUrl: 'https://develop.leads.catch-talents.dev',
  apiUrl: 'https://develop.api.catch-talents.dev',
  apiUrlFallback: 'https://develop.api.catch-talents.dev',
  companyBaseUrl: 'https://develop.company-tool.catch-talents.dev',
  jobboardBaseUrl: 'https://develop.jobboard.catch-talents.dev',
};
